module.exports = __webpack_public_path__ + "img/image_2.8d920f64.png";